import React from "react";

import PropTypes from "prop-types";

function Th({ className = "", adaptToContent = false, children }) {
  return (
    <th
      className={`text-left pb-2 text-xl font-medium ${
        adaptToContent ? "min-w-0 w-0" : ""
      } ${className}`}
    >
      {children}
    </th>
  );
}

Th.propTypes = {
  className: PropTypes.string,
  adaptToContent: PropTypes.bool,
  children: PropTypes.node,
};

export default Th;
